import { useEffect } from "react";
import { LanderConfigAction, useLanderConfig } from "../commons/ConfigContext";
import { ExperimentIds } from "../commons/constants/experiment";
import { isControlCohort } from "./helper";
import { System } from "../commons/Constants";
import { rsocRedirect } from "./useRsocExperiment";

/**
 * This is a 3-way experiment:
 * 'off'
 *   > Control
 *   > Regular AdSense ads
 *   > Trigger banner and channel updates
 * 'on'
 *   > Treatment
 *   > GDAds for ParkWeb
 *   > Trigger banner and channel updates
 *   > Does not use multi cohort tracking ids
 * 'rsoc':
 *   > RSOC
 *   > Redirect to SearchHounds
 *   > No tracking
 *   > If rsoc.path is not set, it will go to regular AdSense ads
 */

const experimentId = ExperimentIds.parking_pw_4541_gdads;
const rsocCohort = "rsoc";

export function useGdAdsExperiment() {
  const { landerConfig, landerConfigDispatch } = useLanderConfig();
  const { experiment: { key, cohort } = {} } = landerConfig;

  const isRsocCohort = cohort === rsocCohort;

  // Exclude visitors with rsoc cohort from the standard experiment flow
  const inExperiment = key === experimentId && !isRsocCohort;
  const inTreatmentCohort = inExperiment && cohort && !isControlCohort(cohort);

  // Handle standard experiment flow
  useEffect(() => {
    if (!inExperiment) return;

    landerConfigDispatch({
      type: LanderConfigAction.UPDATE_BANNER_AND_CHANNEL_BY_TREATMENT,
      payload: {
        inTreatmentCohort,
      },
    });
  }, [inExperiment, landerConfigDispatch, inTreatmentCohort]);

  return { inTreatmentCohort, inExperiment, cohort };
}

export function useRsocRedirectGdAdsExperiment() {
  const { landerConfig } = useLanderConfig();
  const { experiment: { key, cohort } = {} } = landerConfig;

  const rsocRedirectEnabled =
    key === experimentId &&
    cohort === rsocCohort &&
    !!landerConfig.rsoc?.path &&
    landerConfig.system === System.PARKWEB &&
    landerConfig.domain?.rootDomain !== "cloudynest.store"; // This domain was reported by Gooogle for paid traffic. This is a temporary fix until we find a better way to detect paid traffic.

  useEffect(() => {
    if (rsocRedirectEnabled) {
      rsocRedirect(landerConfig, experimentId);
    }
  }, [rsocRedirectEnabled, landerConfig]);

  return { rsocRedirectEnabled };
}
